import { BaseService } from '../../infra/base.service'
import type { Search } from './search'
import type { SearchesRepository } from './searches.repository'

export class SearchesService extends BaseService<Search> {
    constructor(private rep: SearchesRepository) {
        super(rep)
    }

    async restart(searchId: string) {
        return await this.rep.restart(searchId)
    }
}
